import classnames from 'classnames';

interface IProps {
  marginTop?: number;
  marginBottom?: number;
  height?: number;
  className?: string;
}

const Separator = ({ className, height = 1, marginBottom = 12, marginTop = 12 }: IProps) => {
  return <div className={classnames('w-full bg-gray-100', className)} style={{ height, marginBottom, marginTop }} />;
};

export default Separator;
